import { InfoBanner } from '@ui';
import { BulkAssignmentCase } from '@/api/apis/case';
import { BulkAssignmentFiltersType } from '../types';
import { isDisabledDetachOnly } from '../utils';
import { GROUP_ROLE_NAME_MAP } from '../constants';

type LastRequiredEmployeeWarningProps = {
  results: BulkAssignmentCase[];
  filters: BulkAssignmentFiltersType;
};

export const LastRequiredEmployeeWarning = ({ results, filters }: LastRequiredEmployeeWarningProps) => {
  if (!isDisabledDetachOnly(filters)) {
    return null;
  }

  const casesWithOneRequiredEmployee = results.filter((caseItem) => {
    const users = caseItem.assignedEmployees?.[filters.group[0]] || [];
    return users.length === 1;
  });

  if (casesWithOneRequiredEmployee.length === 0) {
    return null;
  }

  return (
    <InfoBanner iconType="warning">
      Detaching the last {GROUP_ROLE_NAME_MAP[filters.group[0]]} from a case is not allowed. The following cases on the
      page are affected: {casesWithOneRequiredEmployee.map((c) => c.caseName).join(', ')}
    </InfoBanner>
  );
};
